import {StickyNoteData, useAppDispatch} from '@dv5/domain'
import React, {CSSProperties, FC} from 'react'
import {ColorPicker} from '../common/ColorPicker'
import {ReactionPicker} from '../common/ReactionPicker'
import {COLOR_PRESETS} from "./constants"
import {FontStylePicker} from "./FontStylePicker"
import {useStickyNoteUpdate} from "./useStickyNoteUpdate"
import './StickyNoteToolbar.less'

interface Props {
    canvasId: string
    widgetId: string
    data: StickyNoteData
    toolbarStyles: CSSProperties
    onExpandToFull: () => void
}

export const StickyNoteToolbar: FC<Props> = ({
    canvasId,
    widgetId,
    data,
    toolbarStyles,
    onExpandToFull,
}) => {
    const dispatch = useAppDispatch()

    const { updateData } = useStickyNoteUpdate(canvasId, widgetId, data)

    const handleColorChange = (color: string) => {
        updateData(['bgColor'], {bgColor: color})
    }

    const handleFontStyleChange = (fontStyle: string) => {
        updateData(['fontStyle'], {fontStyle})
    }

    const handleReactionChange = (reactionType: string) => {
        updateData(['reactionType'], {reactionType})
    }
    const expandToFull = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        event.preventDefault()
        onExpandToFull()
    }

    return (
        <div className='sticky-note-toolbar' style={toolbarStyles}>
            <ColorPicker
                value={data.bgColor}
                presets={COLOR_PRESETS}
                onChange={handleColorChange}
            />
            <div className='sticky-note-toolbar__divider' />
            <FontStylePicker
                prefix="sticky-note-toolbar"
                value={data.fontStyle}
                onChange={handleFontStyleChange}
            />
            <div className='sticky-note-toolbar__divider' />
            <ReactionPicker
                value={data.reactionType}
                allowEmpty={true}
                onChange={handleReactionChange}
            />
            <div className='sticky-note-toolbar__divider' />
            <button
                className='sticky-note-toolbar__button sticky-note-toolbar__button--expand'
                onMouseDown={expandToFull}
                aria-label='Expand to full editor'
                type='button'
            >
                ↗
            </button>
        </div>
    )
}
